module.exports = __webpack_public_path__ + "img/safe-symbol@3x.7436ecd9.png";